import React from 'react';

import { Row, Col } from 'antd';
import { InfoBlock, Link } from 'app/components/common';

import './styles.less';

export const NoAuthPage = () => {
    return (
        <div className="page-not-authenticated">
            <InfoBlock>
                <InfoBlock.Header animate id="not-authorized">
                    <span>Welcome to the HOYA Learning Center</span>
                </InfoBlock.Header>
                <InfoBlock.Body>
                    <Row>
                        <Col xs={ 24 } md={ 15 } className="info-section">
                            <span>Please contact our Customer Support staff at <Link href="mailto:hlchelp@hoya.com">hlchelp@hoya.com</Link> for more information.</span>
                        </Col>
                        <Col xs={ 24 } md={ 9 } className="action-section">
                            { /* There are no actions available. */ }
                        </Col>
                    </Row>
                </InfoBlock.Body>
            </InfoBlock>
        </div>
    );
};
